import React from "react";
import { isBefore, addDays } from "date-fns";
import { AgreementInfo } from "../../../api/services";
import { ColorChip } from "../../../components/Chip";

export const AgreementStatusChip: React.FC<{ agreement: AgreementInfo }> = ({
  agreement,
}) => {
  const { cancelledDttm, toDttm } = agreement;
  return cancelledDttm ? (
    <ColorChip label="Cancelled" />
  ) : toDttm != null &&
    isBefore(
      new Date(toDttm),
      addDays(new Date().setUTCHours(0, 0, 0, 0), 1),
    ) ? (
    <ColorChip type="Info" label="Ended" />
  ) : null;
};
